export default{
  computed: {
    filenames(){
      if (!this.files) return []
      return this.files.map(f => f.name)
    },
    filesizes(){
      if (!this.files) return []
      let result = []
      for (let f of this.files) {
        let size = f.size, ar = ['KB', 'MB', 'GB', 'TB'], sizename = 'bytes'
        for (let i = 0; size > 1024 && ar[i]; i++) {
          size = size / 1024
          sizename = ar[i]
        }
        size = Math.round(size * 10) / 10 + ' ' + sizename
        result.push(size)
      }
      return result
    },
    fileexts(){
      if (!this.files) return []
      return this.files.map(f=> {
        let split = f.name.split('.')
        if (split.length < 2) return 'NO_EXT'
        let ext = split.pop().toUpperCase()
        if (ext == 'JPEG') return 'JPG'
        return ext
      })
    },
  },
  watch: {
    fileexts: {
      handler(v){
        this.$emit('fileExtsChange', v)
      },
      deep: true
    }
  }
}